<div class="modal-header pt-4">
  <h5 class="modal-title "></h5>
</div>


<div class="modal-body pt-2">

  <p>El precio seleccionado incluye una oferta especial exclusiva la cual será aplicada al completar su compra,
    deshabilitando cualquier otra oferta exclusiva previamente activa.</p>
  <p *ngIf="availableRewards > 1">Actualmente tiene {{availableRewards}} recompensas disponibles. Presione "MIS
    RECOMPENSAS" para ver las diferentes
    ofertas disponibles y
    pueda elegir su favorita.</p>
  <p *ngIf="availableRewards == 1">Actualmente tiene ${{availableRewards}} recompensa disponible. Presione "MIS
    RECOMPENSAS" para ver las diferentes
    ofertas disponibles y
    pueda elegir su favorita.</p>


</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary banner-button modal-banner-button secondary" data-dismiss="modal"
    (click)="misRecompensas()">MIS
    RECOMPENSAS</button>
  <button type="button" (click)="continuar()" class="btn btn-primary banner-button modal-banner-button"
    ngbAutofocus>CONTINUAR</button>
</div>